<template>
  <search-group
  @search="findData"
  @clear="clearValue"
  :span="24"
  :btnOffset="18"
  :btnSpan="6"
  :inline="true"
  :multipleLines="true"
  >
    <Row class="mb16" :gutter="16">
      <Col span="8">
        <Select v-model="searchData.projectFid" placeholder="项目名称" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in projectList" :key="'s1'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="8">
        <Select v-model="searchData.perTypeCode" placeholder="应用场景" >
          <Option value=''>请选择</Option>
          <Option v-for="(item,index) in sceneList" :key="'s2'+index" :value="item.value">{{item.text}}</Option>
        </Select>
      </Col>
      <Col span="8">
        <DatePicker style="width:100%" v-model="searchData.createTime"  split-panels type="daterange" format="yyyy-MM-dd" placeholder="生效日期筛选"></DatePicker>
      </Col>
    </Row>
    <Row class="mb16" :gutter="16">
      <Col span="16">
        <Input placeholder="请搜索公式名称" v-model="searchData.keyWord"></Input>
      </Col>
    </Row>
  </search-group>
</template>

<script>
import SearchGroup from 'components/SearchGroup/index';
import { queryData } from 'api/formulaconfig'
import { getProjects } from 'api/common'
import { formatDateTime } from "../../../../../utils/format";
export default {
  components:{
    SearchGroup
  },
  props:{
    projectList:{
      type:Array,
      default(){
        return []
      }
    },
    sceneList:{
      type:Array,
      default(){
        return []
      }
    },
  },
  data(){
    return{
      searchData:{
        projectFid:null,
        perTypeCode:null,
        keyWord:'',
        createTime: ['', '']
      },
    }
  },
  computed:{
    searchDataParams(){
      function f(data) {
        return data?formatDateTime(data, false):''
      }
      return {
        projectFid:this.searchData.projectFid,
        perTypeCode:this.searchData.perTypeCode,
        keyWord:this.searchData.keyWord,
        beginDate: f(this.searchData.createTime[0]),
        endDate:f(this.searchData.createTime[1])
      }
    }
  },
  mounted(){
    console.log(this.searchDataParams)
    this.$emit('searchParams', this.searchDataParams);
  },
  methods:{
    findData(){
      this.$emit('searchParams', this.searchDataParams)
    },
    clearValue(){
      this.searchData= {
        projectFid:null,
        perTypeCode:null,
        keyWord:'',
        createTime: ['', '']
      }
    },
  },
}
</script>

<style>

</style>
